import React from 'react';
import { Seo } from '../components/ui/Seo';
import { Hero } from '../components/home/Hero';
import { CompanyOverview } from '../components/home/CompanyOverview';
import { ServicesGrid } from '../components/home/ServicesGrid';
import { Industries } from '../components/home/Industries';
import { WhyChooseUs } from '../components/home/WhyChooseUs';
import { SimpleProcess } from '../components/home/SimpleProcess';
import { StatsBand } from '../components/home/StatsBand';
import { Testimonials } from '../components/home/Testimonials';
import { CtaBanner } from '../components/ui/CtaBanner';
import { useLanguage } from '../i18n/LanguageContext';
export function Home() {
  const {
    p
  } = useLanguage();
  return <>
      <Seo title={p.home.seo.title} description={p.home.seo.description} data-id="element-463" data-mp="2dirtixam6tyk" />
      <Hero data-id="element-464" data-mp="3kvk2ycd6qn2a" />
      <CompanyOverview data-id="element-465" data-mp="3kw1xn4k78t83" />
      <ServicesGrid data-id="element-466" data-mp="3kuqvtaabdvjm" />
      <Industries data-id="element-467" data-mp="3kxd3rb14ad2d" />
      <WhyChooseUs data-id="element-468" data-mp="3owvljxxn680z" />
      <SimpleProcess data-id="element-469" data-mp="3owce5b5mb217" />
      <StatsBand data-id="element-470" data-mp="3ovkjq3nrbaci" />
      <Testimonials data-id="element-471" data-mp="3ov2eihj49lsg" />
      <CtaBanner data-id="element-472" data-mp="3oyq97k0ase8r" />
    </>;
}